import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import DialogStore from "../stores/DialogStore";

const ConfirmDialog = observer(() => {
    return (
        <Dialog open={DialogStore.showDialog} maxWidth="md" fullWidth>
            <DialogTitle
                sx={{
                    borderBottom: "1px solid #e0e0e0",
                }}
            >
                {DialogStore.title}
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <Typography variant="h5">{DialogStore.message}</Typography>
                {DialogStore.node && (
                    <Box sx={{ my: 2 }}>{DialogStore.node()}</Box>
                )}
                <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}
                >
                    <Box>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => DialogStore.onConfirm()}
                        >
                            {DialogStore.yesText}
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => DialogStore.onClose()}
                            sx={{ ml: 1 }}
                        >
                            {DialogStore.noText}
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
});

export default ConfirmDialog;
